import SignUpLayout from '@/pages/entrance/signUp/signUpLayout.vue';
import LogInPage from '@/pages/entrance/logIn/LogInPage.vue';
import LogOutPage from '@/pages/entrance/logOut/LogOutPage.vue';
import RequestResetPasswordPage from '@/pages/entrance/resetPassword/RequestResetPasswordPage.vue';
import HelpIsOnTheWayPage from '@/pages/entrance/resetPassword/HelpIsOnTheWayPage.vue';
import SignUpVerifyPage from '@/pages/entrance/verifyingYourEmail/VerifyingYourEmailLayout.vue';
import YouGotMailPage from '@/pages/entrance/signUp/YouGotMailPage.vue';
import ResetPasswordPage from '@/pages/entrance/resetPassword/ResetPasswordPage.vue';
import AddNewAppAdUnits from '@/pages/applications/AddNewAppAdUnits.vue';
import VueRouter from 'vue-router';
import BiddingReportsPage from '@/pages/monetize/reports/bidding/BiddingReportsPage.vue';
import cvManagerNewEditPage from '@/pages/conversionValue/cvManager/newEdit/CVManagerNewEditPage.vue';
import { safeDigest } from 'services/utils/angularUtils';
import auth from 'services/auth';
import userData from 'services/userData';
import CVManagerViewPage from '@/pages/conversionValue/cvManager/view/CVManagerViewPage.vue';
import SegmentsPage from "@/pages/monetize/segments/SegmentsPage";
import NewEditSegmentPage from "@/pages/monetize/segments/NewEditSegmentPage";

export const paths = {
    monetize: {
        reports: {
            bidding: '/monetize/reports/bidding'
        }
    }
};

export const routes = [
    {
        path: '/login',
        component: LogInPage,
        name: 'login',
        meta: { hideLeftMenu: true }
    },
    {
        path: '/logout',
        component: LogOutPage,
        name: 'logout'
    },
    {
        path: '/forgot/reset',
        component: ResetPasswordPage,
        name: 'forgotReset',
        meta: { hideLeftMenu: true }
    },
    {
        path: '/forgot/sent',
        component: HelpIsOnTheWayPage,
        name: 'forgotSent',
        meta: { hideLeftMenu: true }
    },
    {
        path: '/forgot',
        component: RequestResetPasswordPage,
        name: 'forgot',
        meta: { hideLeftMenu: true }
    },
    {
        path: '/signup/verification',
        component: SignUpVerifyPage,
        name: 'signupverify',
        meta: { hideLeftMenu: true }
    },
    {
        path: '/signup/sent',
        component: YouGotMailPage,
        name: 'signupSent',
        meta: { hideLeftMenu: true }
    },
    {
        path: '/signup',
        component: SignUpLayout,
        name: 'signup',
        meta: { hideLeftMenu: true }
    },
    {
        path: '/applications/newAdUnits/:appKey',
        component: AddNewAppAdUnits,
        props: true,
        name: 'newAdUnits'
    },
    {
        path: `${paths.monetize.reports.bidding}/from/:from/to/:to/break/:breakBy/graphBreak/:graphBreak/adUnit/:adUnit/app/:app/country/:country/adSource/:adSource/testGroup/:testGroup/sort/:sortingMethod`,
        component: BiddingReportsPage,
        name: 'biddingReportsWithParams'
    },
    {
        path: paths.monetize.reports.bidding,
        component: BiddingReportsPage,
        name: 'biddingReports'
    },
    {
        path: '/conversionValue/cvManager/:id/edit',
        component: cvManagerNewEditPage,
        name: 'cvManagerNewEdit',
        props: true
    },
    {
        path: '/conversionValue/cvManager/:selectedSchemaId?',
        component: CVManagerViewPage,
        name: 'cvManagerView',
        props: true
    },
    {
        path: '/monetize/segments/:appKey?',
        component: SegmentsPage,
        name: 'segmentsPage',
        props: true
    },
    {
        path: '/monetize/segments/:appKey/new/:testGroup?',
        component: NewEditSegmentPage,
        name: 'addSegmentsPage',
        props: true
    },
    {
        path: '/monetize/segments/:appKey/:segmentId/:testGroup',
        component: NewEditSegmentPage,
        name: 'editSegmentsPage',
        props: true
    },
    {
        path: '*',
        name: 'empty'
    }
];

const router = new VueRouter({
    routes,
    base: '/partners',
    mode: 'history',
    hash: false
});

router.afterEach(() => {
    safeDigest();
});

router.beforeEach(async (to, from, next) => {
    let nextCalled = false;
    if (auth.isLoggedIn()) {
        await (userData.getUserData().catch(() => {
            auth.logout();

            next({
                to: 'login',
                query: {
                    returnTo: to.path || ''
                }
            });
            nextCalled = true;
        }));

        const isAuthorized = await auth.isPageAuthorized(to.name);
        if (!isAuthorized) {
            next({ path: '/unauthorized' });
            nextCalled = true;
        }
    }
    if (!nextCalled) {
        next();
    }
});

window.vueRouter = router;

export default router;
